module.exports = __webpack_public_path__ + "media/src/img/twitter-icon-blue-83600e7a6ef1f587c00df1720f102c75.svg";